import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import { Station } from "../../../models/Station";
import TRACE_API, { baseQuery, reducerPath } from "../../api_client/trace_api";

const tagTypes = ["Station"];

export type StationAPIEndpointBuilder = EndpointBuilder<
  typeof baseQuery,
  typeof tagTypes[number],
  typeof reducerPath
>;

const stationEndpoints = TRACE_API.injectEndpoints({
  endpoints: (builder: StationAPIEndpointBuilder) => ({
    /*
    |---------------------------------------------------------------------
    |                          Station Queries & Mutations
    |---------------------------------------------------------------------
    */

    fetchAllStations: builder.query<Station[], void>({
      query: () => ({
        url: "/stations",
        method: "GET",
      }),
      providesTags: ["Station"],
    }),

    fetchOneStations: builder.query<Station[], void>({
      query: ({station_id}: any) => ({
        url: `/stations/${station_id}`,
        method: "GET",
      }),
      providesTags: ["Station"],
    }),

    createStation: builder.mutation<void, Station>({
      query(data: any) {
        return {
          url: "/stations",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Site"],
    }),

    updateStation: builder.mutation<void, Station>({
      query({data, station_id}: any) {
        return {
          url: `/stations/${station_id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["Station"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetch,
  useFetchAllStationsQuery,
  useCreateStationMutation,
  useUpdateStationMutation,
} = stationEndpoints;
